import { Flex, Space } from "antd";
import { useTranslate } from "#src/hooks";
import { useAntTheme } from "@/hooks/useAntTheme";
import { PencilSimpleLineIcon } from "@phosphor-icons/react";
import { AddCommentIcon } from "components/icons/";
import { DeleteButton } from "components/DeleteButton/";

const PREFIX = "components.templates.templatePreview.voiceoverNarration";

export const VoiceoverPopoverTitle = ({
  hasItem,
  itemLabel,
  onDelete,
  addKey,
  editKey,
}: {
  hasItem: boolean;
  itemLabel?: React.ReactNode;
  onDelete?: () => void;
  addKey: string;
  editKey: string;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();

  const titleKey = `${PREFIX}.${hasItem ? editKey : addKey}`;
  const flexStyle = {
    textTransform: "uppercase" as const,
    fontWeight: 500,
    fontSize: 12,
    padding: 16,
    borderBottom: `1px solid ${theme.colorBorderSecondary}`,
  };

  if (!hasItem) {
    return (
      <Flex justify="space-between" gap={8} style={flexStyle}>
        <Space align="center">
          <AddCommentIcon size={15} />
          {t(titleKey)}
        </Space>
      </Flex>
    );
  }

  return (
    <Flex justify="space-between" gap={8} style={flexStyle}>
      <Space align="center">
        <PencilSimpleLineIcon />
        {t(titleKey)}
        {itemLabel}
      </Space>
      {onDelete && (
        <DeleteButton
          confirmOkText={t(`${PREFIX}.remove`)}
          onDelete={onDelete}
        />
      )}
    </Flex>
  );
};
